import {getCookie} from "./cookies";

const USER_COOKIE = '_tv_user';

export function isLogged()
{
    return getCookie(USER_COOKIE);
}